import React, { useEffect, useState } from "react";
import { Card, Col, Input, Row, Dropdown, DropdownToggle, DropdownMenu, FormGroup, Label } from "reactstrap";
import { connect } from "react-redux";
import GetSettingWorkflowTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/GetSettingWorkflowTaskService";
import UpdateTaskActiveStatusService from "../../../../../../../Service/OPSServices/WorkflowsService/UpdateTaskActiveStatusService";
import UpdateTaskRolesForTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/UpdateTaskRolesForTaskService";
import notify from '../../../../../../../Notifications/ToastifyActions'

function WorkflowSettings(props) {
  // const [currentPhaseId, setCurrentPhaseId] = useState(props.workflowPhases && props.workflowPhases[0] ? props.workflowPhases[0].id : 0);
  const [currentPhaseId, setCurrentPhaseId] = useState(props.flag == false ? (props.workflowPhases && props.workflowPhases[0]) ? props.workflowPhases[0].id : 0 : props.selectedTask && props.selectedTask.phaseId);
  const [taskList, setTaskList] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [workflowPhaseCount, setWorkflowPhaseCount] = useState([]);
  const [totalWorkflowPhaseCount, setTotalWorkflowPhaseCount] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoding] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const [changedRoles, setChangedRoles] = useState({});
  const [selectedRoleFilter, setSelectedRoleFilter] = useState("");
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [roleDropdownOpen, setRoleDropdownOpen] = useState({});

  useEffect(() => {
    if (props.workflowPhases && props.workflowPhases.length > 0) {
      if (props.flag === false) {
        setCurrentPhaseId(props.workflowPhases[0].id);
      } else if (props.selectedTask && props.selectedTask.phaseId) {
        setCurrentPhaseId(props.selectedTask.phaseId);
      }
    }
  }, [props.workflowPhases, props.flag, props.selectedTask]);
  useEffect(function () {
    setLoding(true);

    var data = {
      settingsWorkflowId: props.settingsWorkflowId,
    };

    GetSettingWorkflowTaskService(props.token, data).then(function (res) {
      if (res) {
        console.log(res)
        setTaskList(res.tasklist || []);
        setAllTasks(res.tasklist || []);
        setRolesList(res.rolesList || []);
        setLoding(false);
      }
    });
  }, [props.settingsWorkflowId]);

  const toggleRoleDropdown = (taskId) => {
    setRoleDropdownOpen((prev) => ({
        ...prev,
        [taskId]: !prev[taskId]
    }));
};

const getCurrentSelectedRoles = (task) => {
    if (changedRoles[task.id] !== undefined) {
        return Array.isArray(changedRoles[task.id]) ? changedRoles[task.id] : [changedRoles[task.id]];
    }
    if (task && task.roleId) {
        return String(task.roleId).split(',').map(id => id.trim());
    }
    return [];
};

const handleRoleCheckboxChange = (taskId, roleId, task) => {
  const currentRoles = getCurrentSelectedRoles(task);
  let updatedRoles = [...currentRoles];
  const stringRoleId = String(roleId);

  if (updatedRoles.includes(stringRoleId)) {
      updatedRoles = updatedRoles.filter(id => id !== stringRoleId);
  } else {
      updatedRoles.push(stringRoleId);
  }

  setChangedRoles((prev) => ({
      ...prev,
      [taskId]: updatedRoles
  }));
  const filteredRoles = updatedRoles.filter(
    role => role !== "None" && role !== null && role !== undefined
);
  let data = {
      taskId: taskId,
      roleId: filteredRoles, 
      settingsWorkflowId: props.settingsWorkflowId
  };

  UpdateTaskRolesForTaskService(props.token, data).then((res) => {
      if (res && res.res) {
          setTaskList(res.res.tasklist || []);
          setAllTasks(res.res.tasklist || []);
          setRolesList(res.res.rolesList || []);
          
          if (filteredRoles.length > 1) {
            notify.NotifySuccess('New Role assignements have been updated successfully. Please update new assignements manually for all the stores for new assignees.')}
      }
  });
};

const getSelectedRoleNames = (task) => {
  const selectedIds = getCurrentSelectedRoles(task);
  if (selectedIds.length === 0) return "--Select Role--";

  const roleNames = rolesList
      .filter(role => selectedIds.includes(String(role.id)))
      .map(role => role.role)
      .join(", ");
  return roleNames ? roleNames : "--Select Role--";
};

  const handlePreviewToggle = () => {
    setIsPreviewMode((prev) => !prev);
  }
  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    if (value) {
      const firstMatch = taskList.find((task) =>
        (task.taskText || "").toLowerCase().includes(value.toLowerCase())
      );

      if (firstMatch) {
        setCurrentPhaseId(firstMatch.WorkflowPhases);
      }
    }
  };

  const handleRoleChange = (taskId, value) => {
    if (value==0){
      return true
    }
    setChangedRoles((prev) => ({
      ...prev,
      [taskId]: value,
    }));
    let data = {
      taskId: taskId,
      roleId: value,
      settingsWorkflowId: props.settingsWorkflowId
    }
    UpdateTaskRolesForTaskService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        setTaskList(res.res.tasklist);
        setAllTasks(res.res.tasklist);
        setRolesList(res.res.rolesList || []);
      }

    })
  };

  const handleActiveChange = function (task) {
    const newStatus = !task.isActive;

    var updated = taskList.map(function (t) {
      if (t.id === task.id) {
        return { ...t, isActive: newStatus };
      }
      return t;
    });
    setTaskList(updated);
    UpdateTaskActiveStatusService(props.token, {
      taskId: task.id,
      isActive: newStatus,
    }).then((res) => {
      console.log("Updated successfully", res);
    });
  };


  // const getFilteredTasks = () => {
  //   return taskList.filter(function (task) {

  //     if (isPreviewMode) {
  //       return true;
  //     }

  //     var phaseMatch =
  //       !currentPhaseId ||
  //       Number(task.WorkflowPhases) === Number(currentPhaseId);

  //     var roleMatch = true;

  //     if (selectedRoleFilter) {
  //       roleMatch =
  //         task.roleId &&
  //         Number(task.roleId) === Number(selectedRoleFilter);
  //     }

  //     return phaseMatch && roleMatch;
  //   });
  // };
  const getFilteredTasks = () => {
    return taskList.filter((task) => {
      const phaseMatch =
        isPreviewMode ||
        !currentPhaseId ||
        Number(task.WorkflowPhases) === Number(currentPhaseId);

      const roleMatch =
        !selectedRoleFilter ||
        Number(task.roleId) === Number(selectedRoleFilter);

      const searchMatch =
        !searchInput ||
        (task.taskText || "").toLowerCase().includes(searchInput.toLowerCase());

      return phaseMatch && roleMatch && searchMatch;
    });
  };

  const getTasksByPhase = (phaseId) => {
    return taskList.filter(
      (task) => Number(task.WorkflowPhases) === Number(phaseId)
    );
  };
  return (
    <>
      <Card className="pr-3 pl-3 pt-1 pb-1 mb-2  card-of-problemarea mt-3">
        <Row>
          <Col md={12}>
          <Row>
            <Col md={3}>
            {/* {props.workflowMainCategory && props.workflowMainCategory.map((workMC) =>
                workMC.id == props.settingsWorkflowId ? (
                  <h5 className="mb-0 mt-2">
                    <b>{workMC.name} </b>
                  </h5>
                ) : (
                  ""
                )
              )} */}
              <div className="d-flex">
                  <label className="worflows-setting-toggle-switch w-25 mb-0">
                    <input
                      type="checkbox"
                      className="d-none"
                      checked={isPreviewMode}
                      onChange={handlePreviewToggle}
                    />
                    <span className="worflows-setting-dot"></span>
                  </label>

                  <span className="mt-1">Preview All Tasks</span>

                </div>
            </Col>
            <Col md={9} className='d-flex justify-content-end'>
              {/* <select
                className="form-control w-25 ml-2 mr-2"
                value={selectedRoleFilter}
                onChange={(e) => setSelectedRoleFilter(e.target.value)}
              >
                <option value="">--All Roles--</option>

                {rolesList.map((role) => (
                  <option key={role.id} value={role.id.toString()}>
                    {role.role}
                  </option>
                ))}
              </select> */}

              <Input
                type="text"
                value={searchInput}
                disabled={loading ? true : false}
                onChange={(e) => handleSearchInputChange(e)}
                className="form-control w-25"
                placeholder="Search Tasks "
              />
            </Col>
          </Row>
          </Col>

          <Col md={12} className="p-2">
            {isPreviewMode ?

              <div className="d-flex ml-2">
                <>
                  {props.workflowPhases
                    ? props.workflowPhases.map((phase) => (
                      <>
                        {props.selectedWorkflowMasterId ==
                          phase.WorkflowsMaster ? (
                          <div
                            className="selected-tab-workflows-previewmode m-2"
                          >
                            <p className="text-center p-0 mb-0" style={{ fontSize: '17px' }} key={phase.id}>
                              <b>{phase.name}</b>
                            </p>
                            {workflowPhaseCount
                              && workflowPhaseCount.map((count) => (
                                <p className="text-center p-0 mb-0 mr-2">
                                  {phase.id === count.WorkflowPhases_id
                                    ? count.attemptedTaskCount +
                                    " of " +
                                    count.taskCount +
                                    " Completed"
                                    : ""}
                                </p>
                              ))
                            }
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ))
                    : ""}
                </>
              </div> :
              <div className="d-flex">
                <>

                  {props.workflowPhases
                    ? props.workflowPhases.map((phase) => (
                      <>
                        <div
                          onClick={() => {
                            if (!loading) {
                              setCurrentPhaseId(phase.id);
                            }
                          }}
                          style={{
                            cursor: loading ? "not-allowed" : "pointer",
                            opacity: loading ? 0.5 : 1
                          }}
                          className={
                            phase.id == currentPhaseId
                              ? "selected-tab-workflows m-2"
                              : "pt-3 pb-3 m-2"
                          }
                        >
                          <p className="text-center p-0 mb-0" style={{ fontSize: '17px' }} key={phase.id}>
                            <b>{phase.name}</b>
                          </p>
                          {workflowPhaseCount
                            && workflowPhaseCount.map((count) => (
                              <p className="text-center p-0 mb-0">
                                {phase.id === count.WorkflowPhases_id
                                  ? count.attemptedTaskCount +
                                  " of " +
                                  count.taskCount +
                                  " Completed"
                                  : ""}
                              </p>
                            ))
                          }

                        </div>
                      </>
                    ))
                    : ""}
                </>
              </div>
            }

          </Col>
        </Row>
      </Card>
      <>

        <Card>
          <Col md={12} className='pb-4'>
          <table className="table" style={{ tableLayout: "fixed", width: "100%" }}>
              <thead>
                <tr>
                  {/* Set explicit widths for the columns */}
                  <th style={{ width: "40%" }}>Task</th>
                  <th style={{ width: "45%" }}>Role</th>
                  <th style={{ width: "15%", textAlign: "center" }}>Active</th>
                </tr>
              </thead>

              {/* <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      <b>Loading task data...</b>
                    </td>
                  </tr>
                ) : taskList && taskList.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data available
                    </td>
                  </tr>
                ) : (
                    getFilteredTasks().map(function (task) {
                      const currentValue =
                        changedRoles[task.id] !== undefined
                          ? changedRoles[task.id]
                          : task.roleId;
                      return (
                        <tr key={task.id}>
                          <td style={{ width: "40%" }}>
                            {task.taskText}
                          </td>

                          <td style={{ width: "30%" }}>
                            {isPreviewMode?
                            <p className="mb-0">{task.roleName}</p>:
                            <select
                              className="form-control w-75"
                              value={currentValue ? currentValue.toString() : ""}
                              onChange={(e) => handleRoleChange(task.id, e.target.value)}
                            >
                              <option value="">--Select Role--</option>

                              {rolesList.map((role) => (
                                <option key={role.id} value={role.id.toString()}>
                                  {role.role}
                                </option>
                              ))}
                            </select>}
                            
                          </td>

                          <td style={{ width: "30%" }}>
                            <input
                            disabled={isPreviewMode}
                              type="checkbox"
                              checked={task.isActive || false}
                              onChange={function () {
                                handleActiveChange(task);
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })
                )}
              </tbody> */}
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      <b>Loading task data...</b>
                    </td>
                  </tr>
                ) : taskList.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data available
                    </td>
                  </tr>
                ) : isPreviewMode ? (
                
                  props.workflowPhases.map((phase) => {

                    const phaseTasks = getFilteredTasks().filter(
                      (task) => Number(task.WorkflowPhases) === Number(phase.id)
                    );

                    if (!phaseTasks.length) return null;

                    return (
                      <React.Fragment key={phase.id}>
                        <tr style={{ background: "#f5f5f5" }}>
                          <td colSpan="3">
                            <b>{phase.name}</b>
                          </td>
                        </tr>

                        {phaseTasks.map((task) => {
                          return (
                            <tr key={task.id}>
                              <td>{task.taskText}</td>
                              
                              <td style={{ whiteSpace: "normal", paddingRight: "15px" }}>
                                <p className="mb-0" style={{ color: "#495057", wordBreak: "break-word" }}>
                                  {getSelectedRoleNames(task) !== "--Select Role--" 
                                    ? getSelectedRoleNames(task) 
                                    : ""}
                                </p>
                              </td>
                              
                              <td style={{ textAlign: "center" }}>
                                <input
                                  disabled
                                  type="checkbox"
                                  checked={task.isActive || false}
                                  readOnly
                                  style={{ cursor: "not-allowed" }}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })
                ) : (
                  getFilteredTasks().map((task) => {
                    return (
                      <tr key={task.id}>
                        <td>{task.taskText}</td>

                        <td>
                          <Dropdown
                            isOpen={roleDropdownOpen[task.id] || false}
                            toggle={() => toggleRoleDropdown(task.id)}
                            className="w-75"
                          >
                            <DropdownToggle
                              caret
                              className="form-control d-flex justify-content-between align-items-center"
                              style={{
                                backgroundColor: "white",
                                color: "#495057",
                                textAlign: "left",
                                width: "100%", 
                              }}
                            >
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  flex: 1,
                                  marginRight: "10px",
                                }}
                              >
                                {getSelectedRoleNames(task)}
                              </span>
                            </DropdownToggle>
                            <DropdownMenu
                              style={{
                                width: "100%",
                                maxHeight: "200px",
                                overflowY: "auto",
                                padding: "10px",
                              }}
                            >
                              {rolesList.map((role) => (
                                <FormGroup check key={role.id} className="m-2">
                                  <Label check style={{ cursor: "pointer", width: "100%" }}>
                                    <Input
                                      type="checkbox"
                                      checked={getCurrentSelectedRoles(task).includes(String(role.id))}
                                      onChange={() =>
                                        handleRoleCheckboxChange(task.id, role.id, task)
                                      }
                                    />
                                    {role.role}
                                  </Label>
                                </FormGroup>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                          
                          <div
                            className="w-75 mt-1 marquee-container" 
                            style={{ padding: "4px 0", overflow: "hidden" }}
                          >
                            <div
                              className="marquee-text"
                              style={{
                                color: "black",
                                fontSize: "13px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {getSelectedRoleNames(task) !== "--Select Role--"
                                ? getSelectedRoleNames(task)
                                : ""}
                            </div>
                          </div>
                        </td>

                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={task.isActive || false}
                            onChange={() => handleActiveChange(task)}
                          />
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </Col>
        </Card>
      </>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    storeOverview: state.accountOverview.store.storeOverview,
    storeProducts: state.accountOverview.store.storeProducts,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(WorkflowSettings);
